import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Consent To Telehealth',
    educationalSlide: `<div>
  <p>
    <span
      >We provide websites and applications through which you can obtain an
      online visit with an independent, licensed health care professional (a
      “Provider”) and mail order pharmacy services for any medications
      prescribed to you by your Provider (collectively, the “Services”). The
      Services constitute a form of telehealth, which involves the delivery of
      health care services using electronic communications between a health care
      provider and a patient who are not in the same physical location.
      Telehealth may be used for diagnosis, treatment, follow-up and/or patient
      education. Telehealth may include, but is not limited to:</span
    >
    <span>&nbsp;</span>
  </p>
  <ul>
    <li>
      <span
        >Electronic transmission of medical records, photo images, personal
        health information or other data between a patient and a Provider;</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >Interactions between a patient and a Provider via audio, video and/or
        asynchronous data communications, such as secure messaging and email;
        and</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >Use of data from remote monitoring devices, medical devices, and sound
        or video files.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <p>
    <span
      >The websites, applications, and information systems used in the Services
      incorporate network and software security protocols to protect the
      privacy, security, and integrity of your health information. As a patient,
      you acknowledge and agree to maintain the privacy and confidentiality of
      your telehealth sessions by conducting them in a private setting and not
      sharing or recording the sessions without explicit permission from your
      Provider.</span
    >
    <span>&nbsp;</span>
  </p>
  <p>
    <span>&nbsp;</span>
    <span>&nbsp;</span>
  </p>
  <p>
    <b>
      <span>Possible Benefits of Telehealth</span>
    </b>
    <span>&nbsp;</span>
  </p>
  <ul>
    <li>
      <span
        >Telehealth can make accessing medical care easier, more efficient, and
        less expensive.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >You can obtain medical care and treatment at times that are convenient
        for you. Our telehealth services are available
      </span>
      <span>24 hours a day, 7 days a week via online messaging</span>
      <span
        >. Please note that response times may vary, and appointments may be
        subject to Provider availability.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >You can interact with providers without the necessity of an in-office
        appointment.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <p>
    <b>
      <span>Possible Limitations of Telehealth</span>
    </b>
    <span>&nbsp;</span>
  </p>
  <ul>
    <li>
      <span
        >Information transmitted to your Provider may not be sufficient to allow
        for appropriate medical decision making or your Provider may not be able
        to provide medical treatment for your condition via telehealth, and you
        may be required to seek alternative care.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >The inability of your Provider to conduct certain tests or assess vital
        signs in person may in some cases prevent the Provider from diagnosing
        or treating you or identifying that you need urgent medical care.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >Your medical care could be delayed due to technological failures that
        interrupt the Services.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >Data security protocols or safeguards could fail and cause a breach of
        your identified health information.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >Due to the nature of the Services and regulatory requirements in
        certain jurisdictions, your treatment options, especially pertaining to
        certain prescriptions, may be limited.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <p>
    <b>
      <span
        >By checking the “Agree” box you accept this Consent to Telehealth, and
        you acknowledge your understanding and agreement to the following:</span
      >
    </b>
    <span>&nbsp;</span>
  </p>
  <ul>
    <li>
      <span
        >I have read this Consent to Telehealth carefully, and understand the
        risks and benefits of the use of telehealth in my medical care and
        treatment.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I give my informed consent to receive medical care and treatment by
        telehealth from Providers affiliated with CMWL. I understand that
        certain procedures, such as prescribing controlled substances or
        ordering specific diagnostic tests, may require additional consent forms
        to be completed separately from this general telehealth consent.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that the delivery of health care services via telehealth
        is an evolving field and that the use of telehealth in my medical care
        and treatment may include uses of technology not specifically described
        in this consent.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that while the use of telehealth may provide potential
        benefits to me, as with any medical care service no such benefits or
        specific results can be guaranteed. My condition may not be cured or
        improved, and in some cases, may get worse.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that I have a duty to answer questions about my health and
        medical history honestly and accurately, and to keep all of my health
        care providers, including my Provider, up-to-date on any changes in my
        health, symptoms, treatments, or medications.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that withholding or providing inaccurate information about
        my health and medical history in order to obtain treatment may result in
        harm to me, including, in some cases, death.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that my Provider may determine in his or her sole
        discretion that my condition is not suitable for treatment using
        telehealth, and that I may need to seek medical care and treatment in
        person or from an alternative source.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that the Services enable coordination and communication
        with a Provider and do not replace my relationship with any existing
        health care provider.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that I cannot obtain emergency care through the Services,
        and I should call 9-1-1 and seek immediate medical treatment if I am
        experiencing a medical emergency. I acknowledge that my location may be
        verified at the beginning of each telehealth session to ensure that the
        Services offered are in accordance with applicable State and Federal
        laws.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that my information, including my identified health
        information, will be collected, used, shared, and protected as described
        in the Privacy Policy.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that I have access to all of my health and wellness
        information pertaining to my telehealth consultation with my Provider in
        accordance with applicable laws and regulations.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that CMWL and my Provider will share my telehealth record
        with my other health care providers only with my consent and at my
        request. I understand that I can have my telehealth record sent to my
        other health care providers by emailing virtualcaresupport@cmwl.com and
        providing my consent along with my health care provider’s name, address,
        and phone number.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >I understand that a technical failure affecting the Services may result
        in the loss of my information and/or interrupt my online visit. In
        addition to any disclaimers that I agreed to by accepting the Terms of
        Use, I agree to hold CMWL and its affiliated Providers harmless for any
        loss of information, delay in care, misinterpretation due to lack of
        physical examination, or other issues inherent to telehealth services
        resulting from a technical failure or the limitations of remote
        healthcare delivery. This limitation of liability does not apply to
        cases of gross negligence or willful misconduct by CMWL or its
        affiliated Providers.&nbsp;</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >In the event of a material breach of this agreement by either party,
        the non-breaching party may terminate this agreement immediately upon
        written notice to the breaching party. I understand that I can withhold
        or withdraw this consent at any time by emailing
        virtualcaresupport@cmwl.com with such instruction. Otherwise, this
        consent will be considered renewed upon each new telehealth consultation
        with a Provider.&nbsp;</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span
        >In the event of termination of services within 3 hours of remitting
        payment, such amounts will be refunded to you.&nbsp; Otherwise, no
        refunds will be processed or granted.&nbsp;</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <ul>
    <li>
      <span>I have read and understood the </span>
      <strong>Privacy Policy</strong>
      <span
        >. I agree and authorize CMWL and my Providers to collect, use, and
        share my information, including my identified health information and
        other information regarding the telehealth exam, as described in the
        Privacy Policy and for any other purposes permitted by law, including
        for treatment, payment, and health care operations purposes.</span
      >
      <span>&nbsp;</span>
    </li>
  </ul>
  <p>
    <span
      >All capitalized terms used in this Consent to Telehealth but not defined
      herein have the meanings assigned to them in the
    </span>
    <span>Terms of Use</span>
    <span
      >. For avoidance of any doubt, the terms “CMWL“, “we“, “us“, or “our”
      refer to BE-THIN, Inc dba The Center for Medical Weight Loss (CMWL) and
      the terms “you” and “yours” refer to the person using the Services.</span
    >
    <span>&nbsp;</span>
  </p>
  <p>
    <span
      >This agreement shall be governed by and construed in accordance with the
      laws of the State of Delaware, without regard to its conflict of law
      provisions. Any legal action or proceeding arising out of or relating to
      this agreement or the Services shall be brought pursuant to our
    </span>
    <strong>Terms and Conditions.</strong>
    <span>&nbsp;&nbsp;</span>
    <span>&nbsp;</span>
  </p>
</div>
`,
    field: 'telehealth_consent',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I Agree',
      name: 'telehealth_consent_consent'
    }
  }
];

export default questionsModels;
